import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { Contrato, Prestador, Regra, Gestor, ProfissionalExecutanteContrato, IRequestMessage } from '@/types/_'
import Apis from '@/Apis/_'
import { Contrato as Contract } from '@/types/core'

@Module({ namespaced: true, name: 'BackofficeContratosStore' })
export default class BackofficeContratosStore extends VuexModule {
  private contract: Contract.IContrato = new Contract.Contrato()
  public requestMessage: IRequestMessage = {
    avancar: {
      text: 'Carregando...',
    },
    search: 'Buscando...',
    continuarDepois: {
      text: 'Enviando...',
    },
    init: {
      text: 'Carregando...',
    },
    status: true,
    deleteMessage: 'Deletando...',
    post: 'Enviando...',
    update: 'Atualizando...',
    messageFinish: 'Solicitação enviada com sucesso!',
    errorApi: 'Houve um erro no envio dos dados.',
    errorUpload: '',
  }

  private gestoresDefault: Gestor[] = []
  private profissionaisExecutantesDefault: ProfissionalExecutanteContrato[] = []
  private prestadoresDefault: Prestador[] = []
  private prestadorDefault: Prestador = { id: '', nome: '', documento: '' }
  private regrasDefault: Regra[] = []
  private contratosDefault: Contrato[] = []
  private contratoDefault: Contrato = {
    id: '',
    nome: '',
    status: '',
    prestador: {
      id: '',
      nome: '',
      documento: '',
    },
    fontePagadora: {
      id: '',
      nome: '',
      documento: '',
    },
    inicioVigencia: null,
    fimVigencia: null,
    regras: [],
    gestores: [],
    profissionaisExecutantes: [],
  }

  private gestorDefault: Gestor = {
    id: '',
    nome: '',
    email: null,
    cpf: null,
  }

  private profissionalExecutanteDefault: ProfissionalExecutanteContrato = {
    id: '',
    nome: '',
    crm: null,
    crmUf: null,
    email: null,
    cpf: null,
  }

  public modal: any = {
    addRegrasList: false,
    addProfissionaisList: false,
    addGestoresList: false,
    removeRegraList: false,
    removeProfissionalList: false,
    removeGestorList: false,
    novoContrato: false,
  }

  public prestadoresTableHeader: any[] = [
    { text: '', value: 'nome', sortable: false },
    { text: '', value: 'documento', sortable: false },
  ]

  public regrasTableHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Regra', value: 'nome', sortable: false },
    { text: 'Tipo da regra', value: 'tipoRegra', sortable: false },
    { text: 'Tipo de cálculo', value: 'calculo', sortable: false },
    { text: '', value: '', sortable: false },
  ]

  public gestoresExibicaoTableHeader: any[] = [
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'E-mail', value: 'email', sortable: false },
    { text: 'CPF', value: 'cpf', sortable: false },
    { text: '', value: '', sortable: false },
  ]

  public profissionaisExibicaoTableHeader: any[] = [
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'CRM', value: 'crm', sortable: false },
    { text: 'UF', value: 'crmUf', sortable: false },
    { text: 'E-mail', value: 'email', sortable: false },
    { text: 'CPF', value: 'cpf', sortable: false },
    { text: '', value: '', sortable: false },
  ]

  public gestoresTableHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'E-mail', value: 'email', sortable: false },
    { text: 'CPF', value: 'documento', sortable: false },
  ]

  public profissionaisTableHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'CRM', value: 'crm', sortable: false },
    { text: 'UF', value: 'crmUf', sortable: false },
    { text: 'E-mail', value: 'email', sortable: false },
    { text: 'CPF', value: 'cpf', sortable: false },
  ]

  public contratosTableHeader: any[] = [
    { text: 'Contrato', value: 'descricao', sortable: false },
    { text: 'Fonte Pagadora', value: 'fontePagadora', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: '', sortable: false },
  ]

  public prestadoresSearch: string = ''
  public prestadoresSearchCache: string = ''
  public gestoresSearch: string = ''
  public regrasSearch: string = ''
  public profissionaisSearch: string = ''
  public removeRegraId: string = ''
  public removeProfissionalId: string = ''
  public removeGestorId: string = ''
  public selectedRegras: Regra[] = []
  public selectedProfissionais: ProfissionalExecutanteContrato[] = []
  public selectedGestores: Gestor[] = []

  public gestores: Gestor[] = [...this.gestoresDefault]
  public profissionaisExecutantes: ProfissionalExecutanteContrato[] = [...this.profissionaisExecutantesDefault]
  public regras: Regra[] = [...this.regrasDefault]
  public prestadores: Prestador[] = [...this.prestadoresDefault]
  public prestador: Prestador = { ...this.prestadorDefault }
  public contratos: Contrato[] = [...this.contratosDefault]
  public contrato: Contrato = { ...this.contratoDefault }
  public gestor: Gestor = { ...this.gestorDefault }
  public profissionalExecutante: ProfissionalExecutanteContrato = { ...this.profissionalExecutanteDefault }
  public fontesPagadoras: any[] = []
  public prestadoresRecebimento: any[] = []
  public selectedFontePagadora: string = ''
  public selectedPrestador: string = ''
  public selectedInicioVigencia: string = ''
  public contratosGestor: any[] = []
  public contratosGestorBaseRemuneracao: any[] = []
  public selectedContratoGestor: any = {}
  public filterDrawer: boolean = false
  public grupoHospitalOptions: any[] = []
  public filtroCpfGestor: string = ''
  public filtroGestor: string = ''
  public filtroCnpjPrestador: string = ''
  public filtroPrestador: string = ''
  public filtroGrupoHospital: string = ''
  public pagination: any = {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: null
  }
  public paginationRemuneracao: any = {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: null
  }
  public loadingTabelaContratos: boolean = false

  // Nome configurado por cliente (Recebimento.Hospital); fonte pagadora fora do escopo do usuário cai na razão social
  get resolveNomeFontePagadora() {
    const nomesPorId = new Map(
      this.fontesPagadoras.map((fp: Pick<Contrato['fontePagadora'], 'id' | 'nome'>): [string, string] => [fp.id, fp.nome]),
    )

    return (fontePagadora: Contrato['fontePagadora']) => nomesPorId.get(fontePagadora?.id) || fontePagadora?.nome
  }

  @Mutation
  clearNovoContrato() {
    this.selectedFontePagadora = ''
    this.selectedPrestador = ''
    this.selectedInicioVigencia = ''
  }

  @Mutation
  setSelectedInicioVigencia(value: string) {
    this.selectedInicioVigencia = value
  }

  @Mutation
  setSelectedPrestador(value: string) {
    this.selectedPrestador = value
  }

  @Mutation
  setSelectedFontePagadora(value: string) {
    this.selectedFontePagadora = value
  }

  @Mutation
  setShowModalAddGestoresList(value: boolean) {
    this.modal.addGestoresList = value
  }

  @Mutation
  setShowModalAddProfissionaisList(value: boolean) {
    this.modal.addProfissionaisList = value
  }

  @Mutation
  setShowModalAddRegrasList(value: boolean) {
    this.modal.addRegrasList = value
  }

  @Mutation
  setShowModalRemoveRegraList(value: boolean) {
    this.modal.removeRegraList = value
  }

  @Mutation
  setShowModalRemoveProfissionalList(value: boolean) {
    this.modal.removeProfissionalList = value
  }

  @Mutation
  setShowModalRemoveGestorList(value: boolean) {
    this.modal.removeGestorList = value
  }

  @Mutation
  setSelectedRegras(value: Regra[]) {
    this.selectedRegras = value
  }

  @Mutation
  setSelectedProfissionais(value: ProfissionalExecutanteContrato[]) {
    this.selectedProfissionais = value
  }

  @Mutation
  setSelectedGestores(value: Gestor[]) {
    this.selectedGestores = value
  }

  @Mutation
  setRemoveRegraId(value: string) {
    this.removeRegraId = value
  }

  @Mutation
  setRemoveProfissionalId(value: string) {
    this.removeProfissionalId = value
  }

  @Mutation
  setRemoveGestorId(value: string) {
    this.removeGestorId = value
  }

  @Mutation
  setPrestadores(value: Prestador[]) {
    this.prestadores = value
  }

  @Mutation
  setFontesPagadoras(value: any[]) {
    this.fontesPagadoras = value
  }

  @Mutation
  setPrestadoresRecebimento(value: any[]) {
    this.prestadoresRecebimento = value
  }

  @Mutation
  setShowModalNovoContrato(value: boolean) {
    this.modal.novoContrato = value
  }

  @Mutation
  setRegras(value: Regra[]) {
    this.regras = value
  }

  @Mutation
  setPrestador(value: Prestador) {
    this.prestador = value
  }

  @Mutation
  clearSelectedRegras() {
    this.selectedRegras = []
  }

  @Mutation
  clearSelectedProfissionais() {
    this.selectedProfissionais = []
  }

  @Mutation
  clearSelectedGestores() {
    this.selectedGestores = []
  }

  @Mutation
  clearPrestadores() {
    this.prestadores = [...this.prestadoresDefault]
  }

  @Mutation
  clearPrestador() {
    this.prestador = { ...this.prestadorDefault }
  }

  @Mutation
  setContratos(value: Contrato[]) {
    this.contratos = value
  }

  @Mutation
  setContrato(value: Contrato) {
    this.contrato = value
  }

  @Mutation
  setPrestadoresSearch(value: string) {
    this.prestadoresSearch = value
  }

  @Mutation
  setPrestadoresSearchCache(value: string) {
    this.prestadoresSearchCache = value
  }

  @Mutation
  setRegrasSearch(value: string) {
    this.regrasSearch = value
  }

  @Mutation
  setGestoresSearch(value: string) {
    this.gestoresSearch = value
  }

  @Mutation
  setProfissionaisSearch(value: string) {
    this.profissionaisSearch = value
  }

  @Mutation
  setGestores(value: Gestor[]) {
    this.gestores = value
  }

  @Mutation
  setGestor(value: Gestor) {
    this.gestor = value
  }

  @Mutation
  setProfissionaisExecutantes(value: ProfissionalExecutanteContrato[]) {
    this.profissionaisExecutantes = value
  }

  @Mutation
  setProfissionalExecutante(value: ProfissionalExecutanteContrato) {
    this.profissionalExecutante = value
  }

  @Mutation
  clearRemoveRegraId() {
    this.removeRegraId = ''
  }

  @Mutation
  clearRemoveProfissionalId() {
    this.removeProfissionalId = ''
  }

  @Mutation
  clearRemoveGestorId() {
    this.removeGestorId = ''
  }

  @Mutation
  clearContratos() {
    this.contratos = [...this.contratosDefault]
  }

  @Mutation
  clearRegras() {
    this.regras = [...this.regrasDefault]
  }

  @Mutation
  clearContrato() {
    this.contrato = { ...this.contratoDefault }
  }

  @Mutation
  clearPrestadoresSearch() {
    this.prestadoresSearch = ''
  }

  @Mutation
  clearPrestadoresSearchCache() {
    this.prestadoresSearchCache = ''
  }

  @Mutation
  clearRegrasSearch() {
    this.regrasSearch = ''
  }

  @Mutation
  clearGestoresSearch() {
    this.gestoresSearch = ''
  }

  @Mutation
  clearProfissionaisSearch() {
    this.profissionaisSearch = ''
  }

  @Mutation
  clearGestores() {
    this.gestores = [...this.gestoresDefault]
  }

  @Mutation
  clearGestor() {
    this.gestor = { ...this.gestorDefault }
  }

  @Mutation
  clearProfissionaisExecutantes() {
    this.profissionaisExecutantes = [...this.profissionaisExecutantesDefault]
  }

  @Mutation
  clearProfissionalExecutante() {
    this.profissionalExecutante = { ...this.profissionalExecutanteDefault }
  }

  @Mutation
  removeRegra(regraId: string) {
    const index = this.contrato.regras.findIndex((e: any) => e.id === regraId)
    this.contrato.regras.splice(index, 1)
  }

  @Mutation
  removeProfissional(profissionalId: string) {
    const index = this.contrato.profissionaisExecutantes.findIndex((e: any) => e.id === profissionalId)
    this.contrato.profissionaisExecutantes.splice(index, 1)
  }

  @Mutation
  removeGestor(gestorId: string) {
    const index = this.contrato.gestores.findIndex((e: any) => e.id === gestorId)
    this.contrato.gestores.splice(index, 1)
  }

  @Mutation
  adicionaRegras(rs: Regra[]) {
    const diff = _.differenceBy([...rs], [...this.contrato.regras], 'id')
    diff.forEach((e: any) => this.contrato.regras.push(e))
  }

  @Mutation
  adicionaProfissionais(pf: ProfissionalExecutanteContrato[]) {
    const diff = _.differenceBy([...pf], [...this.contrato.profissionaisExecutantes], 'id')
    diff.forEach((e: any) => this.contrato.profissionaisExecutantes.push(e))
  }

  @Mutation
  adicionaGestores(gs: Gestor[]) {
    const diff = _.differenceBy([...gs], [...this.contrato.gestores], 'id')
    diff.forEach((e: any) => this.contrato.gestores.push(e))
  }

  @Mutation
  setContratosGestor(value: any[]) {
    this.contratosGestor = value
  }

  @Mutation
  setContratosGestorBaseRemuneracao(value: any[]) {
    this.contratosGestorBaseRemuneracao = value
  }

  @Mutation
  setSelectedContratoGestor(value: any) {
    this.selectedContratoGestor = value
  }

  @Mutation
  setFilterDrawer(value: boolean) {
    this.filterDrawer = value
  }

  @Mutation
  setFiltroCpfGestor(value: string) {
    this.filtroCpfGestor = value
  }

  @Mutation
  setFiltroGestor(value: string) {
    this.filtroGestor = value
  }

  @Mutation
  setFiltroCnpjPrestador(value: string) {
    this.filtroCnpjPrestador = value
  }

  @Mutation
  setFiltroPrestador(value: string) {
    this.filtroPrestador = value
  }

  @Mutation
  setFiltroGrupoHospital(value: string) {
    this.filtroGrupoHospital = value
  }

  @Mutation
  setGrupoHospitalOptions(value: any[]) {
    this.grupoHospitalOptions = value
  }

  @Mutation
  setPagination(pagination: any) {
    this.pagination = pagination
  }

  @Mutation
  setPaginationRemuneracao(pagination: any) {
    this.paginationRemuneracao = pagination
  }

  @Mutation
  setPagina(page: number) {
    this.pagination.page = page
  }

  @Mutation
  setPaginaRemuneracao(page: number) {
    this.paginationRemuneracao.page = page
  }

  @Mutation
  setLoadingTabelaContratos(value: boolean) {
    this.loadingTabelaContratos = value
  }

  @Action
  async addNovoContrato() {
    try {
      const params: any = {
        prestadorId: this.selectedPrestador,
        fontePagadoraId: this.selectedFontePagadora,
        inicioVigencia: this.selectedInicioVigencia ? `${this.selectedInicioVigencia}-01T00:00` : null,
        nome: 'Repasse Médico',
      }
      const request = await this.contract.addNovoContrato(params)
      return request
    } catch (error) {
      return { success: false, message: 'Erro ao adicionar novo contrato' }
    }
  }

  @Action
  async getAllFontesPagadoras() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFontePagadoraAll()
      if (request.success) this.context.commit('setFontesPagadoras', request.data)
      return request
    } catch (error) {
      return []
    }
  }

  @Action
  async getAllPrestadoresRecebimento(params: { limite?: number, filtro?: string }) {
    try {
      const temPontuacao = (texto) => /[.,\/#!$%\^&\*;:{}=\-_`~()?]/.test(texto)
      let filtro = params.filtro || ''

      if (filtro && temPontuacao(filtro)) {
        filtro = filtro.replace(/[.\-/]/g, '')
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPrestadores({ limite: params.limite, filtro: filtro })
      if (request.success) this.context.commit('setPrestadoresRecebimento', request.data.prestadores)
      return request
    } catch (error) {
      return []
    }
  }

  @Action
  async getAllContratos(prestadorId: string) {
    try {
      const request = await this.contract.getAllContratos(prestadorId)
      if (request.success) {
        this.context.commit('setPrestador', this.prestadores.find((e: Prestador) => e.id === prestadorId))
        this.context.commit('setContratos', request.data)
      }
      return []
    } catch (error) {
      return []
    }
  }

  @Action
  async getAllRegras() {
    try {
      const request = await this.contract.getAllRegrasDisponiveis(this.contrato.id)
      if (request.success) this.context.commit('setRegras', request.data.regras)
      return []
    } catch (error) {
      return []
    }
  }

  @Action
  async getAllProfissionais() {
    try {
      const request = await this.contract.getAllProfissionais()
      if (request.success) this.context.commit('setProfissionaisExecutantes', request.data)
      return []
    } catch (error) {
      return []
    }
  }

  @Action
  async getAllPrestadoresByHospital() {
    try {
      const request = await this.contract.getAllPrestadoresByHospital()
      if (request.success) this.context.commit('setPrestadores', request.data)
      return []
    } catch (error) {
      return []
    }
  }

  @Action
  async getPrestadoresBySearch(payload: { search: string, limite?: number }) {
    const request = await Apis.Contrato.ContratoApi.getPrestadoresBySearch(payload.search, payload.limite)
    if (request.success) this.context.commit('setPrestadores', request.data)
    return request
  }

  @Action
  async getAllGestores() {
    try {
      const request = await this.contract.getAllGestores()
      if (request.success) this.context.commit('setGestores', request.data)
      return []
    } catch (error) {
      return []
    }
  }

  @Action
  async getGestoresBySearch(payload: { nome?: string, cpf?: string, limite?: number }) {
    const request = await Apis.Contrato.ContratoApi.getGestoresBySearch(payload)
    if (request.success) this.context.commit('setGestores', request.data)
    return request
  }

  @Action
  async getProfissionaisBySearch(payload: { nome?: string, cpf?: string, limite?: number }) {
    const request = await Apis.Contrato.ContratoApi.getProfissionaisBySearch(payload)
    if (request.success) this.context.commit('setProfissionaisExecutantes', request.data)
    return request
  }

  @Action
  async getContratoById(id: string) {
    try {
      const request = await this.contract.getContratoById(id)
      if (request.success) this.context.commit('setContrato', request.data)
      return this.contrato
    } catch (error) {
      return this.contrato
    }
  }

  @Action
  async removeRegraById() {
    try {
      const request = await this.contract.deleteRegrasByContratoId(this.contrato.id, this.removeRegraId)
      if (request.success) {
        this.context.commit('removeRegra', this.removeRegraId)
        this.context.commit('clearRemoveRegraId')
        return this.contrato
      }
      return { error: request.message }
    } catch (error) {
      return this.contrato
    }
  }

  @Action
  async removeProfissionalById() {
    try {
      const profissionais = [this.removeProfissionalId]
      const request = await this.contract.deleteProfissionaisByContratoId(this.contrato.id, profissionais)
      if (request.success) {
        this.context.commit('removeProfissional', this.removeProfissionalId)
        this.context.commit('clearRemoveProfissionalId')
        return this.contrato
      }
      return { error: request.message }
    } catch (error) {
      return this.contrato
    }
  }

  @Action
  async removeGestorById() {
    try {
      const gestor = [this.removeGestorId]
      const request = await this.contract.deleteGestoresByContratoId(this.contrato.id, gestor)
      if (request.success) {
        this.context.commit('removeGestor', this.removeGestorId)
        this.context.commit('clearRemoveGestorId')
        return this.contrato
      }
      return { error: request.message }
    } catch (error) {
      return this.contrato
    }
  }

  @Action
  async addRegras() {
    try {
      const rgs = _.map(this.selectedRegras, 'id')
      const request = await this.contract.postRegrasByContratoId(this.contrato.id, rgs)
      if (request.success) {
        this.context.commit('adicionaRegras', this.selectedRegras)
        this.context.commit('clearSelectedRegras')
        return this.contrato
      }
      return { error: request.message }
    } catch (error) {
      return this.contrato
    }
  }

  @Action
  async addProfissionais() {
    try {
      const profissionais = _.map(this.selectedProfissionais, 'id')
      const request = await this.contract.postProfissionaisByContratoId(this.contrato.id, profissionais)
      if (request.success) {
        this.context.commit('adicionaProfissionais', this.selectedProfissionais)
        this.context.commit('clearSelectedProfissionais')
        return this.contrato
      }
      return { error: request.message }
    } catch (error) {
      return this.contrato
    }
  }

  @Action
  async addGestores() {
    try {
      const gestores = _.map(this.selectedGestores, 'id')
      const request = await this.contract.postGestoresByContratoId(this.contrato.id, gestores)
      if (request.success) {
        this.context.commit('adicionaGestores', this.selectedGestores)
        this.context.commit('clearSelectedGestores')
        return this.contrato
      }
      return { error: request.message }
    } catch (error) {
      return this.contrato
    }
  }

  @Action
  async getContratosVisaoGestor(params?: any) {
    try {
      params = {
        ...params,
        pagina: this.pagination.page,
        qtdPorPagina: this.pagination.rowsPerPage,
        codigoGrupoHospital: this.filtroGrupoHospital,
        cpfUsuario: this.filtroCpfGestor,
        nomeUsuario: this.filtroGestor,
        cnpjPrestador: this.filtroCnpjPrestador,
        nomePrestador: this.filtroPrestador,
      }

      const request = await this.contract.getContratosVisaoGestor('contrato', params)

      if (request.success) {
        this.context.commit('setContratosGestor', request.data.itens)
        this.context.commit('setPagination', { totalItems: request.data.totalRegistros, rowsPerPage: request.data.qtdPorPagina, page: request.data.paginaAtual })
      }

      return request
    } catch (error) {
      return { success: false, message: 'Erro ao buscar contratos' }
    }
  }

  @Action
  async getContratosVisaoGestorBaseRemuneracao(params?: any) {
    try {
      params = {
        ...params,
        pagina: this.paginationRemuneracao.page,
        qtdPorPagina: this.paginationRemuneracao.rowsPerPage,
        codigoGrupoHospital: this.filtroGrupoHospital,
        cpfUsuario: this.filtroCpfGestor,
        nomeUsuario: this.filtroGestor,
        cnpjPrestador: this.filtroCnpjPrestador,
        nomePrestador: this.filtroPrestador,
      }

      const request = await this.contract.getContratosVisaoGestor('principal', params)

      if (request.success) {
        this.context.commit('setContratosGestorBaseRemuneracao', request.data.itens)
        this.context.commit('setPaginationRemuneracao', { totalItems: request.data.totalRegistros, rowsPerPage: request.data.qtdPorPagina, page: request.data.paginaAtual })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Erro ao buscar contratos' }
    }
  }


  @Action
  async getGrupoHospitalOptions() {
    try {
      const response = await this.contract.getGrupoHospitalOptions()
      if (response.success) {
        this.context.commit('setGrupoHospitalOptions', response.data.codigosGruposHospitais)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Erro ao buscar grupos hospitalares' }
    }
  }
}
